/*@flow*/
import nested from 'lib/nested';

export default (
  place: $Shape<Goog$PlaceT>
): $Shape<{ fullAddress: string, theGeom: string, center: Object }> => {
  const formattedAddress = nested(place, 'formatted_address');
  const loc = nested(place, 'geometry.location');

  if (!loc) return {};
  const lon = loc.lng();
  const lat = loc.lat();

  return {
    fullAddress: formattedAddress,
    theGeom: `POINT (${lon} ${lat})`,
    center: { lat, lon },
  };
};
